export const PUMP_REQUEST_TYPE = 'pumpRequestType';
export const PUMP_GENERAL_REQUEST = 'generalPumpRequest';
export const PUMP_SPECIFIC_REQUEST = 'specificPumpRequest';
export const PUMP_SYSTEMFLUID = 'systemfluid';
export const PUMP_STEERING = 'steering';
export const PUMP_ALARM = 'alarm';
export const PUMP_EXTERNAL_STOP = 'externalStop';
export const PUMP_CARD = 'card';
export const PUMP_PRESSURE = 'pressure';